<div class="account-pages my-5 pt-5">
  <div class="container">
    <div class="text-center mb-5">
      <h1 class="display-2 fw-bold" style="color:#0d631b;">404</h1>
      <p class="h4 mb-2">Page introuvable</p>
      <p class="text-secondary">Le lien est peut-être ancien ou mal saisi.</p>
      <div class="mt-4">
        <a class="btn fw-semibold px-4" style="background:#0d631b;color:#fff;" routerLink="/">Retour au tableau de bord</a>
      </div>
    </div>
  </div>
</div>
